import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import styled, { css } from '@xstyled/styled-components';
import { UniversalLink } from '@trybeapp/ui.universal-link';
import { themePath, system } from '@trybeapp/ui.system';

var _templateObject;
var Link = /*#__PURE__*/styled(UniversalLink)(function (_ref) {
  var variant = _ref.variant;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    opacity: 1;\n    text-decoration: none;\n    cursor: pointer;\n    transition: opacity 300ms;\n\n    &:hover,\n    &:focus {\n      outline: none;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &[disabled] {\n      opacity: 0.5;\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n\n    ", ";\n    ", ";\n    ", ";\n\n    & > *:not(:only-child):not(:last-child) {\n      margin-right: xs;\n    }\n  "])), themePath('links.default'), themePath("links." + (variant || 'primary')), system);
});

export { Link };
